import React from "react";

export default function Statistics_Descriptive() {
  return (
    <div>
      <h1>Statistics_Descriptive</h1>
      <p>This is the Statistics_Descriptive component.</p>
    </div>
  );
}
